import { Store } from 'utils';

class Move extends Store {

	getInitialState() {
		return {
			resumes: [],
			folder: null,
			inProgress: false,
			resumesExist: []
		}
	}
	onMoveInProgress(state, data) {
		state.resumes = data.resumes;
		state.folder = data.toFolder;
		state.inProgress = true;

	}

	onMoveFinished(state,data) {
		state.inProgress = false;
		state.resumes = data.resumes;
		state.resumesExist = data.exist;
	}

	onMoveDone(state) {
		state.folder = null;
		state.resumes = [];
	}
	onMoveClosed(state) {
		state.resumes = [];
		state.resumesExist = [];
	}

	onPageLoading(state, page) {
		this.onMoveDone(state);
	}
}

const store = new Move();
export default store;


// WEBPACK FOOTER //
// ./src/modules/model/Move.js